<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6 register-section-wrapper">
        <!-- <div class="brand-wrapper">
            <img src="../assets/images/logo.svg" alt="logo" class="logo">
          </div> -->
        <div v-if="!successful"
             class="register-wrapper my-auto">
          <h1 class="register-title">Sign up</h1>
          <Form @submit="handleRegister"
                :validation-schema="schema">
            <div class="form-row">
              <div class="form-group col-5">
                <label>First Name</label>
                <Field name="firstName"
                       type="text"
                       class="form-control" />
                <ErrorMessage name="firstName"
                              class="error-feedback" />
              </div>

              <div class="form-group col-5">
                <label>Last Name</label>
                <Field name="lastName"
                       type="text"
                       class="form-control" />
                <ErrorMessage name="lastName"
                              class="error-feedback" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label>School</label>
                <Field name="school"
                       as="select"
                       class="form-control">
                  <option v-for="(value, key) in schools"
                          :value="value.id"
                          :key="key">{{ value.school_fullname_en }}</option>
                </Field>
                <ErrorMessage name="school"
                              class="error-feedback" />
              </div>

            </div>
            <div class="form-row">
              <div class="form-group col">
                <label>Username</label>
                <Field name="username"
                       type="text"
                       class="form-control" />
                <ErrorMessage name="username"
                              class="error-feedback" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label>Email</label>
                <Field name="email"
                       type="text"
                       class="form-control" />
                <ErrorMessage name="email"
                              class="error-feedback" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label>Password</label>
                <Field name="password"
                       type="password"
                       class="form-control" />
                <ErrorMessage name="password"
                              class="error-feedback" />
              </div>
              <div class="form-group col">
                <label>Confirm Password</label>
                <Field name="confirmPassword"
                       type="password"
                       class="form-control" />
                <ErrorMessage name="confirmPassword"
                              class="error-feedback" />
              </div>
            </div>
            <!-- <div class="form-group form-check">
              <Field name="acceptTerms"
                     type="checkbox"
                     value="true"
                     class="form-check-input" />
              <label @click="modalOpen = true"
                     class="form-check-label">Accept Terms & Conditions</label>

              <modal-button></modal-button>
              <ErrorMessage name="acceptTerms"
                            class="error-feedback" />
            </div> -->
            <div class="form-group">
              <button class="btn btn-primary btn-block"
                      :disabled="loading">
                <span v-show="loading"
                      class="spinner-border spinner-border-sm"></span>
                Sign Up
              </button>
            </div>
          </Form>
          <div v-if="message" 
               class="alert"
               :class="successful ? 'alert-success' : 'alert-danger'">
            <li v-for="(value, key) in message"
                :value="key"
                :key="key">{{ value.toString() }}</li>
          </div>
          <p class="register-wrapper-footer-text">Aleady have an account?
            <router-link to="/login">Log in</router-link>
          </p>
        </div>
      </div>
      <div class="col-sm-6 px-0 d-none d-sm-block">
        <img src="../assets/images/login.jpg"
             alt="register image"
             class="register-img">
      </div>
    </div>
  </div>
  <!-- <teleport to="body">
    <div v-if="modalOpen"
         class="modal">
      <div>
        <h3 class="modal-header">Terms & Conditions</h3>
      </div>
      <div>
        <p>The aim of this "App Inventor Code Analyzer" platform is to provide support to teachers for assessing and analyzing the student projects based on the Computational Thinking Concepts and MIT App Inventor Components used. Information obtained from the platform may be used in future research and may be published. Howerver, your right to privacy will be retained. i.e., students personal details will not be revealed.</p>
        <p>This platform is developed by Centre for Learning, Teaching and Technology of The Education University of Hong Kong under the govemance of Professor Kong Siu Cheung, Director of The Centre for Learning, Teaching and Technology. The Education University has the ownership of this platform and reserves the rights for further development, updates and revision.</p>
        <p>Your participation is voluntary. By clicking the "Accept terms and conditions" button, prior to the first time of using this platfrom, you understand the benefits and risks involved.</p>
      </div>
      <div>
        <button type="button"
                class="btn-confirm"
                @click="modalOpen = false">close</button>
      </div>
    </div>
  </teleport> -->
</template>

<script>
import { Form, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import UserService from '../services/user.service'

export default {
  name: 'register',
  components: {
    Form,
    Field,
    ErrorMessage,
  },

  data() {
    const schema = yup.object().shape({
      school: yup.string().required('School is required'),
      firstName: yup.string().required('First Name is required'),
      lastName: yup.string().required('Last name is required'),
      username: yup.string().required('Username is required'),
      email: yup
        .string()
        .required('Email is required')
        .email('Email is invalid'),
      password: yup
        .string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters'),
      confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required')
      // acceptTerms: yup.string().required('Accept Ts & Cs is required')
    })

    return {
      successful: false,
      loading: false,
      message: '',
      schema,
      schools: [],
      modalOpen: false,
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    },
  },
  mounted() {
    // console.log(this.$route.query.survey_id)
    // console.log(this.$route.query.response_id)
    if(!(this.$route.query.survey_id && this.$route.query.response_id)){
                  window.location.href = "https://eduhk.au1.qualtrics.com/jfe/form/SV_86XAqAqFqsAPQWy"
    }


    UserService.getSchoolList().then((res) => {
      // for (let item in res.data) {
      //   res.data[item].addr_value = Number(item) + 1
      // }
      // res.data = res.data.sort(function (a, b) {
      //   var x = a['school_fullname_en']
      //   var y = b['school_fullname_en']
      //   return x < y ? -1 : x > y ? 1 : 0
      // })
      this.schools = res.data
    })
    
    if (this.loggedIn) {
      this.$router.push('/analyzer')
    }
  },
  methods: {
    handleRegister(user) {
      this.message = ''
      this.successful = false
      this.loading = true
      // console.log(user)
      user.survey_id = this.$route.query.survey_id
      user.response_id = this.$route.query.response_id

      this.$store.dispatch('auth/register', user).then(
        (response) => {
          this.message = response.message
          this.successful = true
          this.loading = false
          this.$router.push('/registersuccess')
        },
        (error) => {
          this.message = error.response.data
          this.successful = false
          this.loading = false
        }
      )
    },
  },
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: rgba(0,0,0,.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modal div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  width: 800px;
  /* height: 700px; */
  padding: 5px;
}

.btn-close,
.btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color: transparent;
}
.btn-confirm {
  color: #fff;
  background-color: #2d8cf0;
}

label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
